export default "__VITE_ASSET__CpmjdU78__"